import Vue from 'vue'

// 深拷贝
import './deepClone'

// 获取当前时间
import './getTime'

// 加载loading
import './loading'


import selectLable from './selectLable';
Vue.prototype.$selectLable = selectLable
import jumptable from './jumpTable';
Vue.prototype.$table = jumptable

// 定时器
import timer from './timer'
Vue.prototype.$timer = timer

// Bus
import bus from './bus'
Vue.prototype.$bus = bus

// 订单金额格式化
import formatOrderAmt from './formatOrderAmt';
Vue.prototype.$formatOrderAmt = formatOrderAmt